module.exports = __webpack_public_path__ + "static/img/3.7347ad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/3.jpg
// module id = GUy4
// module chunks = 0